import { configPromise } from "../../config/configMiddleware";
import { deleteWith, getWith, patchWith, postWith, updateWith } from "../axios";

export async function addDueDiligence(data: any) {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/duediligenceV2/`;
    return (await postWith<any, any>(url, data)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function deleteDueDiligence(id: string): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/duediligenceV2/hard-delete/${id}`;
    return (await deleteWith<any, any>(url, {})) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function softDeleteDueDiligence(id: string): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/duediligenceV2/soft-delete/${id}`;
    return (await deleteWith<any, any>(url, {})) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function restoreDueDiligence(
  id: string | undefined
): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/duediligenceV2/restore/${id}`;
    return (await updateWith<any, any>(url, {})) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function getDueDiligenceByID(
  id: string | undefined
): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/duediligenceV2/${id}`;

    return (await getWith<any>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function updateDueDiligence(
  id: any,
  data: string | undefined
): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/duediligenceV2/${id}`;
    return (await patchWith<any, any>(url, data)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}
